/* Pampino Slide-out-Warenkorb: Hinzufuegen, Menge, Entfernen, Upsell */
(function () {
  var d = document;
  var SECTION = 'pampino-cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = d.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var panel = drawer.querySelector('.pp-drawer__panel');
  var lastFocus = null;

  function open() {
    lastFocus = d.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    d.documentElement.classList.add('pp-lock');
    setTimeout(function () { panel.focus(); }, 60);
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    d.documentElement.classList.remove('pp-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(n) {
    var link = d.getElementById('pp-cart-link');
    if (!link) return;
    var badge = link.querySelector('[data-cart-count]');
    if (n > 0) {
      if (!badge) {
        badge = d.createElement('span');
        badge.className = 'pp-count';
        badge.setAttribute('data-cart-count', '');
        link.appendChild(badge);
      }
      badge.textContent = n;
    } else if (badge) {
      badge.remove();
    }
    link.setAttribute('aria-label', 'Warenkorb, ' + n + ' Artikel');
  }

  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    var current = drawer.querySelector('[data-cart-inner]');
    if (!fresh || !current) return;
    current.innerHTML = fresh.innerHTML;
    updateCount(parseInt(fresh.getAttribute('data-count') || '0', 10));
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }

  function busy(on) { panel.classList.toggle('is-busy', on); }

  function errorBox() {
    var box = d.querySelector('[data-atc-error]');
    var main = d.querySelector('[data-atc-main]');
    if (!box && main) {
      box = d.createElement('p');
      box.className = 'pp-form-error';
      box.setAttribute('role', 'alert');
      box.setAttribute('data-atc-error', '');
      box.hidden = true;
      main.insertAdjacentElement('afterend', box);
    }
    return box;
  }

  /* Produkt hinzufuegen, ohne Seitenwechsel */
  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    var btns = d.querySelectorAll('[data-atc]');
    var err = errorBox();
    if (err) err.hidden = true;
    btns.forEach(function (b) { b.classList.add('is-loading'); });

    post('cart/add.js', {
      items: [{ id: Number(fd.get('id')), quantity: parseInt(fd.get('quantity') || '1', 10) }],
      sections: SECTION
    }).then(function (res) {
      if (!res.ok) {
        if (err) { err.textContent = res.data.description || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.'; err.hidden = false; }
        return;
      }
      render(res.data.sections && res.data.sections[SECTION]);
      open();
    }).catch(function () {
      form.submit();
    }).then(function () {
      btns.forEach(function (b) { b.classList.remove('is-loading'); });
    });
  });

  /* Klicks im Warenkorb */
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { close(); return; }

    var qty = e.target.closest('[data-line]');
    if (qty) {
      busy(true);
      post('cart/change.js', { line: Number(qty.getAttribute('data-line')), quantity: Number(qty.getAttribute('data-qty')), sections: SECTION })
        .then(function (res) { if (res.ok) render(res.data.sections && res.data.sections[SECTION]); })
        .catch(function () {})
        .then(function () { busy(false); });
      return;
    }

    var up = e.target.closest('[data-add-variant]');
    if (up) {
      busy(true);
      post('cart/add.js', { items: [{ id: Number(up.getAttribute('data-add-variant')), quantity: 1 }], sections: SECTION })
        .then(function (res) { if (res.ok) render(res.data.sections && res.data.sections[SECTION]); })
        .catch(function () {})
        .then(function () { busy(false); });
    }
  });

  /* Header-Warenkorb oeffnet die Schublade */
  d.addEventListener('click', function (e) {
    var link = e.target.closest('#pp-cart-link');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open();
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* Fokus bleibt im offenen Warenkorb */
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (d.activeElement === first || d.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
